import { FmDataOutputTable } from "../FmDataOutputTable";
import { Checkbox, DataSource, HorizontalSpacer, Label, Layout, Panel, Switch, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutFreightMatchingControl extends Layout {
    checkboxAutoDispatch: Checkbox;
    checkboxBookingNotifyCarrier: Checkbox;
    checkboxBookingNotifyDispatcher: Checkbox;
    checkboxBookingNotifyEntered: Checkbox;
    checkboxBookingNotifyOperations: Checkbox;
    checkboxBookingNotifyRevCode: Checkbox;
    checkboxBookingNotifySales: Checkbox;
    checkboxCanRetrieveOfferStatus: Checkbox;
    checkboxCanSendEquipPrefs: Checkbox;
    checkboxCanSendLanePrefs: Checkbox;
    checkboxCancelAvailableTractors: Checkbox;
    checkboxClearPayInfo: Checkbox;
    checkboxCreateAvailableTractors: Checkbox;
    checkboxCreateAvailableTractorsOffer: Checkbox;
    checkboxCreateCallin: Checkbox;
    checkboxCreateMcPosition: Checkbox;
    checkboxCreateOrderHistComment: Checkbox;
    checkboxDontSendDocsImaging: Checkbox;
    checkboxEnableBookingEmail: Checkbox;
    checkboxEnableCarrierDriver: Checkbox;
    checkboxEnableCarrierEquipment: Checkbox;
    checkboxEnableCarrierOffer: Checkbox;
    checkboxEnableComment: Checkbox;
    checkboxEnableLoadBooking: Checkbox;
    checkboxEnableMilestones: Checkbox;
    checkboxEnableResponsibility: Checkbox;
    checkboxEnableSettlementStatus: Checkbox;
    checkboxEnableUnassignmentEmail: Checkbox;
    checkboxEnabledCarrierUnassign: Checkbox;
    checkboxExcludeCustomerFilter: Checkbox;
    checkboxExcludeLockedMovements: Checkbox;
    checkboxExcludeOrderType: Checkbox;
    checkboxExcludeOrdersOnHold: Checkbox;
    checkboxExcludeRevcodeFilter: Checkbox;
    checkboxExcludeStatusFilter: Checkbox;
    checkboxIncludeProhibited: Checkbox;
    checkboxIsPayRateProvider: Checkbox;
    checkboxNotifyArcFailure: Checkbox;
    checkboxNotifyOnBookFailure: Checkbox;
    checkboxNotifyOnOfferFailure: Checkbox;
    checkboxOfferNotifyCarrier: Checkbox;
    checkboxOfferNotifyDispatcher: Checkbox;
    checkboxOfferNotifyEnabled: Checkbox;
    checkboxOfferNotifyEntered: Checkbox;
    checkboxOfferNotifyOperations: Checkbox;
    checkboxOfferNotifyRevCode: Checkbox;
    checkboxOfferNotifySales: Checkbox;
    checkboxOverridePayAmt: Checkbox;
    checkboxReceiveCcArc: Checkbox;
    checkboxRetrieveAvailableTractors: Checkbox;
    checkboxSendArc: Checkbox;
    checkboxStoreTemperature: Checkbox;
    checkboxUpdateScheduledCallTime: Checkbox;
    checkboxUseDfmEta: Checkbox;
    horizontalspacer1: HorizontalSpacer;
    labelBookingUserRoles: Label;
    labelLoadDetailsAlerts: Label;
    labelLoadWindow: Label;
    labelNotifications: Label;
    labelOfferNotifications: Label;
    labelOfferRecipients: Label;
    labelOfferUserRoles: Label;
    labelRecipients: Label;
    labelToday: Label;
    layoutCarrierDataOutput: FmDataOutputTable;
    layoutLoadDataOutput: FmDataOutputTable;
    layoutSettlementDataOutput: FmDataOutputTable;
    panelBookingNotifications: Panel;
    panelBookingUserRoles: Panel;
    panelBrkStatus: Panel;
    panelCustomer: Panel;
    panelOfferNotifications: Panel;
    panelOfferUserRoles: Panel;
    panelOrderType: Panel;
    panelRevCode: Panel;
    sourceDfmTrackingProviders: DataSource;
    sourceFreightMatchingControl: DataSource;
    sourceFreightMatchingDataOutputCarrier: DataSource;
    sourceFreightMatchingDataOutputLoad: DataSource;
    sourceFreightMatchingDataOutputSettlement: DataSource;
    sourceFreightMatchingProfile: DataSource;
    sourceFreightMatchingUsers: DataSource;
    switchIsActiveControl: Switch;
    tabCarrierBooking: Tab;
    tabCarriers: Tab;
    tabDataOutput: Tab;
    tabLoadBooking: Tab;
    tabLoads: Tab;
    tabProfiles: Tab;
    tabSettlements: Tab;
    tabTrackingProviders: Tab;
    tabUserAccess: Tab;
    tabVisibility: Tab;
    tableDfmTrackingProviders: Table;
    tableFreightMatchingUsers: Table;
    tableProfiles: Table;
    tabsetDataOutput: Tabset;
    tabsetFreightMatching: Tabset;
    tabsetProviders: Tabset;
    textboxAutoRateConfirmTemplate: Textbox;
    textboxBrkQualProfOverride: Textbox;
    textboxBrokerageCode: Textbox;
    textboxBrokerageStatusFilter: Textbox;
    textboxCarrierOfferFilter: Textbox;
    textboxCarrierQualStatus: Textbox;
    textboxCarrierReturnLimit: Textbox;
    textboxCarrierStatus: Textbox;
    textboxCommentType: Textbox;
    textboxCustomerFilter: Textbox;
    textboxDaysAfter: Textbox;
    textboxDaysPrior: Textbox;
    textboxIncludedContacts: Textbox;
    textboxIncludedLoadboardValue: Textbox;
    textboxLastProcessDatetime: Textbox;
    textboxLoadReturnLimit: Textbox;
    textboxMovementStatus: Textbox;
    textboxNotifyBookingGroups: Textbox;
    textboxNotifyBookingUsers: Textbox;
    textboxOfferCarrierWarning: Textbox;
    textboxOfferFailReasons: Textbox;
    textboxOfferMaxPayOverride: Textbox;
    textboxOfferNotifyEmails: Textbox;
    textboxOfferNotifyGroups: Textbox;
    textboxOfferNotifyUsers: Textbox;
    textboxOrderModeFilter: Textbox;
    textboxOrderTypeFilter: Textbox;
    textboxOtherBookingEmails: Textbox;
    textboxPostedType: Textbox;
    textboxProcessInterval: Textbox;
    textboxRateConfirmationFrom: Textbox;
    textboxRevcodeFilter: Textbox;
    textboxTractorBrokerageCode: Textbox;
}
